export * from './news.service';


// WEBPACK FOOTER //
// ./src/app/news/services/index.ts